module.exports = __webpack_public_path__ + "static/media/buffaloAppTemplate.32459e4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/logs/buffalo/buffaloAppTemplate.png
// module id = 720
// module chunks = 0